// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SelectInput_wrapper__r2CjD","select":"SelectInput_select__Yw7C3","icon":"SelectInput_icon__6_PWg"};